import React from 'react'
import MyMemberContainer from '../../Containers/MyMembers'
function Supplier() {
  return (
    <MyMemberContainer/>
  )
}

export default Supplier